module.exports = "<span class=\"js-anchor form-label__error-button-anchor\"></span>";